import { Injectable } from '@angular/core';
import {RoleAction} from "../../../models/custom-models/role-action";

@Injectable({
  providedIn: 'root'
})
export class RoleActionsService {

  constructor() { }

  getRoleActions() {
    return this.userRoles as RoleAction[];
  }

  private userRoles = [
    {
      "actionId": 1,
      "roleId": 1
    },
    {
      "actionId": 1,
      "roleId": 2
    },
    {
      "actionId": 2,
      "roleId": 2
    },
    {
      "actionId": 1,
      "roleId": 3
    },
    {
      "actionId": 2,
      "roleId": 3
    },
    {
      "actionId": 3,
      "roleId": 3
    },
    {
      "actionId": 1,
      "roleId": 4
    },
    {
      "actionId": 3,
      "roleId": 4
    },
    {
      "actionId": 1,
      "roleId": 5
    },
    {
      "actionId": 2,
      "roleId": 5
    },
    {
      "actionId": 4,
      "roleId": 5
    },
    {
      "actionId": 1,
      "roleId": 6
    },
    {
      "actionId": 2,
      "roleId": 6
    },
    {
      "actionId": 3,
      "roleId": 6
    },
    {
      "actionId": 4,
      "roleId": 6
    },
    {
      "actionId": 1,
      "roleId": 7
    },
    {
      "actionId": 2,
      "roleId": 7
    },
    {
      "actionId": 3,
      "roleId": 7
    },
    {
      "actionId": 4,
      "roleId": 7
    },
    {
      "actionId": 6,
      "roleId": 7
    },
    {
      "actionId": 9,
      "roleId": 7
    },
    {
      "actionId": 1,
      "roleId": 8
    },
    {
      "actionId": 2,
      "roleId": 8
    },
    {
      "actionId": 3,
      "roleId": 8
    },
    {
      "actionId": 4,
      "roleId": 8
    },
    {
      "actionId": 6,
      "roleId": 8
    },
    {
      "actionId": 7,
      "roleId": 8
    },
    {
      "actionId": 9,
      "roleId": 8
    },
    {
      "actionId": 1,
      "roleId": 9
    },
    {
      "actionId": 2,
      "roleId": 9
    },
    {
      "actionId": 3,
      "roleId": 9
    },
    {
      "actionId": 4,
      "roleId": 9
    },
    {
      "actionId": 6,
      "roleId": 9
    },
    {
      "actionId": 7,
      "roleId": 9
    },
    {
      "actionId": 8,
      "roleId": 9
    },
    {
      "actionId": 9,
      "roleId": 9
    },
    {
      "actionId": 1,
      "roleId": 10
    },
    {
      "actionId": 2,
      "roleId": 10
    },
    {
      "actionId": 3,
      "roleId": 10
    },
    {
      "actionId": 4,
      "roleId": 10
    },
    {
      "actionId": 5,
      "roleId": 10
    },
    {
      "actionId": 6,
      "roleId": 10
    },
    {
      "actionId": 7,
      "roleId": 10
    },
    {
      "actionId": 8,
      "roleId": 10
    },
    {
      "actionId": 9,
      "roleId": 10
    },
    {
      "actionId": 1,
      "roleId": 11
    },
    {
      "actionId": 2,
      "roleId": 11
    },
    {
      "actionId": 3,
      "roleId": 11
    },
    {
      "actionId": 4,
      "roleId": 11
    },
    {
      "actionId": 5,
      "roleId": 11
    },
    {
      "actionId": 6,
      "roleId": 11
    },
    {
      "actionId": 7,
      "roleId": 11
    },
    {
      "actionId": 8,
      "roleId": 11
    },
    {
      "actionId": 9,
      "roleId": 11
    },
    {
      "actionId": 10,
      "roleId": 11
    },
    {
      "actionId": 1,
      "roleId": 12
    },
    {
      "actionId": 2,
      "roleId": 12
    },
    {
      "actionId": 3,
      "roleId": 12
    },
    {
      "actionId": 4,
      "roleId": 12
    },
    {
      "actionId": 5,
      "roleId": 12
    },
    {
      "actionId": 6,
      "roleId": 12
    },
    {
      "actionId": 7,
      "roleId": 12
    },
    {
      "actionId": 8,
      "roleId": 12
    },
    {
      "actionId": 9,
      "roleId": 12
    },
    {
      "actionId": 10,
      "roleId": 12
    },
    {
      "actionId": 14,
      "roleId": 12
    },
    {
      "actionId": 2,
      "roleId": 13
    },
    {
      "actionId": 1,
      "roleId": 14
    },
    {
      "actionId": 2,
      "roleId": 14
    },
    {
      "actionId": 3,
      "roleId": 14
    },
    {
      "actionId": 4,
      "roleId": 14
    },
    {
      "actionId": 5,
      "roleId": 14
    },
    {
      "actionId": 6,
      "roleId": 14
    },
    {
      "actionId": 7,
      "roleId": 14
    },
    {
      "actionId": 8,
      "roleId": 14
    },
    {
      "actionId": 9,
      "roleId": 14
    },
    {
      "actionId": 10,
      "roleId": 14
    },
    {
      "actionId": 11,
      "roleId": 14
    },
    {
      "actionId": 1,
      "roleId": 15
    },
    {
      "actionId": 2,
      "roleId": 15
    },
    {
      "actionId": 3,
      "roleId": 15
    },
    {
      "actionId": 4,
      "roleId": 15
    },
    {
      "actionId": 5,
      "roleId": 15
    },
    {
      "actionId": 6,
      "roleId": 15
    },
    {
      "actionId": 7,
      "roleId": 15
    },
    {
      "actionId": 8,
      "roleId": 15
    },
    {
      "actionId": 9,
      "roleId": 15
    },
    {
      "actionId": 10,
      "roleId": 15
    },
    {
      "actionId": 11,
      "roleId": 15
    },
    {
      "actionId": 14,
      "roleId": 15
    },
    {
      "actionId": 102,
      "roleId": 101
    },
    {
      "actionId": 104,
      "roleId": 101
    },
    {
      "actionId": 105,
      "roleId": 101
    },
    {
      "actionId": 102,
      "roleId": 102
    },
    {
      "actionId": 103,
      "roleId": 102
    },
    {
      "actionId": 104,
      "roleId": 102
    },
    {
      "actionId": 105,
      "roleId": 102
    },
    {
      "actionId": 101,
      "roleId": 111
    },
    {
      "actionId": 103,
      "roleId": 111
    },
    {
      "actionId": 112,
      "roleId": 111
    },
    {
      "actionId": 113,
      "roleId": 111
    },
    {
      "actionId": 101,
      "roleId": 112
    },
    {
      "actionId": 103,
      "roleId": 112
    },
    {
      "actionId": 112,
      "roleId": 112
    },
    {
      "actionId": 113,
      "roleId": 112
    },
    {
      "actionId": 114,
      "roleId": 112
    },
    {
      "actionId": 113,
      "roleId": 113
    },
    {
      "actionId": 111,
      "roleId": 121
    },
    {
      "actionId": 114,
      "roleId": 121
    },
    {
      "actionId": 122,
      "roleId": 121
    },
    {
      "actionId": 123,
      "roleId": 121
    },
    {
      "actionId": 111,
      "roleId": 122
    },
    {
      "actionId": 114,
      "roleId": 122
    },
    {
      "actionId": 122,
      "roleId": 122
    },
    {
      "actionId": 123,
      "roleId": 122
    },
    {
      "actionId": 124,
      "roleId": 122
    },
    {
      "actionId": 123,
      "roleId": 123
    },
    {
      "actionId": 121,
      "roleId": 131
    },
    {
      "actionId": 124,
      "roleId": 131
    },
    {
      "actionId": 131,
      "roleId": 131
    },
    {
      "actionId": 132,
      "roleId": 131
    },
    {
      "actionId": 121,
      "roleId": 132
    },
    {
      "actionId": 124,
      "roleId": 132
    },
    {
      "actionId": 131,
      "roleId": 132
    },
    {
      "actionId": 132,
      "roleId": 132
    },
    {
      "actionId": 133,
      "roleId": 132
    },
    {
      "actionId": 132,
      "roleId": 133
    }
  ]
}
